<span class="field-view-value">{{ formattedInterval }}</span>
